import styles from './stylea.module.scss'
import VioletCircleIcon from './icons/violet-circle.svg'

import Img1 from './images/img_1.png'
import Img2 from './images/img_2.png'
import Img3 from './images/img_3.png'
import Img4 from './images/img_4.png'
import CoinWalletGetWallet from './components/get-wallet'
import { useTranslation } from 'utils/use-translation'

export default function CoinWalletWorthRelyingOn({ pageCurrency }) {
  const  { t, locale, replacePlaceholders } = useTranslation()
  const placeholders = {
    ticker: pageCurrency.ticker
  }
  
  return (
    <section className={styles.relying}>
      <div className={styles.relying__title}>
        <h2>{replacePlaceholders(t('worth_relying'), placeholders)}</h2>
        {locale === 'en' && <img src={VioletCircleIcon} alt="violet circle icon" />}
      </div>
      <div className={styles.main}>
        <div className={styles.main__item}>
          <img src={Img1} alt="crypto control icon" />
          <p>{t('crypto_control')}</p>
        </div>

        <div className={styles.main__item}>
          <img src={Img2} alt="cryptocurrencies icon" />
          <p>{t('available_cryptos')}</p>
        </div>

        <div className={styles.main__item}>
          <img src={Img3} alt="24/7 support icon" />
          <p>{t('customer_support_247')}</p>
        </div>

        <div className={styles.main__item}>
          <img src={Img4} alt="special offers icon" />
          <p>{t('get_offers')}</p>
        </div>
      </div>

      <CoinWalletGetWallet pageCurrency={pageCurrency} />
    </section>
  )
}
